export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS 24 Juni 2024.c216cb1f.pdf";